import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSaved } from "@/context/SavedContext";

export default function SaveButton({ listingId, className = "", size = 20, testId, unsavedColorClass = "text-white/90" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const saved = useSaved();
  const isSaved = saved?.ids?.has(listingId);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { nav("/login"); return; }
    try {
      const nowSaved = await saved.toggle(listingId);
      toast.success(nowSaved ? "Saved to wishlist" : "Removed from wishlist");
    } catch { toast.error("Failed"); }
  };

  return (
    <button
      onClick={onClick}
      aria-label={isSaved ? "Remove from saved" : "Save listing"}
      data-testid={testId}
      className={`grid place-items-center transition-colors duration-200 ${className}`}
    >
      <Heart
        size={size}
        className={`transition-colors duration-200 ${isSaved ? "fill-safety text-safety" : `${unsavedColorClass} hover:text-safety`}`}
      />
    </button>
  );
}
